import React from 'react';
import {UiText} from '~/components/elements';

interface Props {
  text: string;
  pattern?: RegExp;
}

const SpecialText = ({text, pattern = /b!(\w+)/}: Props) => {
  const match = text.match(pattern);

  if (match !== null) {
    const beforeMatch = text.substring(0, match.index ?? undefined);
    const afterMatch = text.substring((match.index ?? 0) + match[0].length);
    const boldText = <strong>{match[1]}</strong>;

    return (
      <span style={{marginBottom: '1.5rem', fontWeight: 400}}>
        <span style={{fontSize: '0.875rem', fontWeight: 400}}>{beforeMatch}</span>
        <span style={{fontWeight: 700}}>{boldText}</span>
        <span style={{fontSize: '0.875rem', fontWeight: 400}}>{afterMatch}</span>
      </span>
    );
  }
  return (
    <UiText color="blackSecondary" fontSize="sm">
      {text}
    </UiText>
  );
};

export default SpecialText;
